import 'construct-style-sheets-polyfill'; const styleSheet = new CSSStyleSheet(); styleSheet.replaceSync(`input[type='radio'] {
    opacity: 0;
}

label {
    font-size: 1em;
}

input {
    cursor: pointer;
}

input:disabled {
    cursor: initial;
}

input:checked + label {
    border-radius: 1em;
    outline: 0.2em solid var(--inv-input-radio-checked-outline-color, #0e4dab);
}

.input-container {
    width: 10em;
    height: 10em;
    border-radius: 1em;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.text-container {
    display: flex;
    height: 100%;
    width: 100%;
    border-radius: 1em;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: white;
}

.text-container.disabled {
    background: #f0f5f9;
}

.input-container:focus-within {
    outline: none;
    border: 0.1em solid var(--inv-input-radio-focus-border-color, #0e4dab);
}

.input-container.disabled {
    opacity: 0.3;
}

.end-addornment {
    position: inherit;
    margin: 0;
}

.radio-subtitle {
    margin-top: 0.66666em;
    --inv-text-s-color: #9498af;
}

.radio-title {
    --inv-text-l-font-size: 1em;
    --inv-text-l-font-weight: 600;
    text-align: center;
    padding: 0 1.6em;
}

input {
    position: absolute;
    height: 10em;
    width: 10em;
}

.radio-icon-container {
    margin-bottom: 0.66666em;
}
`); export default styleSheet;